import { PassengerIcon } from '@/root/ui/shared/icons/PassengerIcon'
import { FC } from 'react'
import { BicycleIcon } from '@/root/ui/shared'

interface NumOfTicketItemsProps {
  count: number
  iconType: 'bicycle' | 'passenger'
}

export const NumberOfTicketItems: FC<NumOfTicketItemsProps> = ({ iconType, count }) => {
  if (!count) {
    return null
  }

  return (
    <div className="flex items-center gap-3">
      <div>
        {iconType === 'bicycle' ? <BicycleIcon width={35} height={22} color="black" /> : <PassengerIcon width={15} />}
      </div>
      <div className="text-4xl">{count}</div>
    </div>
  )
}

export default NumberOfTicketItems
